<template>

    <div id="import-recharges">
        <Button 
            class="mt-2"
            :size="15" 
            color="#2da44e" 
            colorText="#ffffff" 
            tooltip="Importador Recargos" 
            icon="fas fa-upload" 
            round 
            :width="30"  
            @click.native="openModal('modal')"
            translate 
        />

        <ui-modal 
            :title="`Importador Recargos`"
            size="large" 
            ref="modal" 
            @close="closeModal('modal')"
        >
            <div class="container-fluid mb-3">
                <div class="row w-100">
                    <div class="col">
                        <small> - El campo 'NETA' y 'PUBLICA' debe ser campo númerico con decimales por puntos.</small>
                        <br />
                        <small> - Los campos 'DESDE' y 'HASTA' deben tener el formato '01-12-2024'.</small>
                    </div>
                </div>
                <div class="row mt-4 w-100">
                    <div class="col-6">
                        <div class="w-100 d-inline">
                            <input 
                                class="import b-order" 
                                type="file"
                                ref="fileToImport"
                                id="fileToImport"
                                name="fileToImport" 
                                @change="getFile()"
                                accept=".xlsx"
                            />
                            <span v-if="showDeleteBtn" class="delete zoom" @click="clearInput()">
                                <i class="fas fa-trash-alt"></i>
                            </span>
                        </div>
                        
                    </div>
                    <div class="col-6">
                        <div class="d-flex justify-content-between px-5 mt-1">
                            <span class="mt-1 d-flex"> Con error : <div class="info ml-2 red"></div></span>
                            <span class="mt-1 d-flex"> Modificar : <div class="info ml-2 blue"></div></span>
                            <span class="mt-1 d-flex"> Agregar :   <div class="info ml-2 green"></div></span>
                        </div>
                    </div>
                </div>

                <div class="row w-100 mt-4">
                    <div class="col">
                        <div v-if="showTable" class="w-100 table-helper">
                            <table class="table table-bordered table-hover text-center">
                                <thead>
                                    <tr>
                                        <th> ID </th>
                                        <th> Naviera </th>
                                        <th> Naviera Salida </th>
                                        <th> Código </th>  
                                        <th> POL </th>  
                                        <th> POD </th>  
                                        <th> Desde </th>  
                                        <th> Hasta </th>  
                                        <th> Moneda </th>
                                        <th> Neta (Costo) </th>
                                        <th> Venta (Pública) </th>
                                        <th> Átmosfera </th>
                                        <th> Unidad </th>
                                        <th> Commodity </th>
                                        <th> Unidad Pago </th>
                                    </tr>

                                </thead>
                                
                                <tbody>
                                    <tr v-for="(item,i) in data" :key="i">

                                        <td :class="item.id.change"> {{ item.id.value }} </td>
                                        <td :class="item.naviera_id.change"> {{ item.naviera_id.name }} </td>
                                        <td :class="item.naviera_id_departure.change"> {{ item.naviera_id_departure.name }} </td>
                                        <td :class="item.code.change"> {{ item.code.value }}  </td>
                                        <td :class="item.pol.change"> {{ item.pol.name }} </td>
                                        <td :class="item.pod.change"> {{ item.pod.name }} </td>
                                        <td :class="item.from_format.change"> {{ item.from_format.value }} </td>
                                        <td :class="item.to_format.change"> {{ item.to_format.value }} </td>
                                        <td :class="item.currency_id.change"> {{ item.currency_id.name }} </td>
                                        <td :class="item.neta.change"> {{ item.neta.value }} </td>
                                        <td :class="item.public_value.change"> {{ item.public_value.value }} </td>
                                        <td :class="item.atmosphere_id.change"> {{ item.atmosphere_id.name }}</td>
                                        <td :class="item.container_id.change"> {{ item.container_id.name }} </td>
                                        <td :class="item.products_category_id.change"> {{ item.products_category_id.name }} </td>
                                        <td :class="item.unit_payment.change"> {{ item.unit_payment.name }}  </td>

                                    </tr>
                                </tbody>
                                
                            </table>
                        </div>
                        <div v-else class="w-100 h-100 b-order">
                            <div class="w-100 h-100 message-wait">
                                <h1>Esperando carga de archivo...</h1>
                            </div>
                        </div>
                    </div>
                </div>

                <div class="row w-100 mt-3">
                    <div class="col">
                        <div class="w-100 d-flex justify-content-between">
                            <button 
                                class="btn btn-default" 
                                @click="closeModal('modal')"
                                :disabled="btnDisabled"    
                            >
                                Cerrar
                            </button>
                            <button 
                                :disabled="btnDisabled"
                                class="btn btn-warning"
                                @click="handleSubmit()"
                            > Importar 
                            </button>
                        </div>
                    </div>
                </div>
            </div>
        </ui-modal>
    </div>

</template>

<script>
import { mapActions, mapState } from 'vuex' ;
import UiModal from "keen-ui/src/UiModal";
import Button from '../../../../common/Button.vue';
import readXlsxFile from 'read-excel-file/web-worker';
import { formatDate, validateFormatDecimal } from '../../../../../mixins';
import { getRechargeFiltros, importTariffRecharges } from '../../../../../constants/lineas';


const Changes = {
    NOT_CHANGES : "" ,
    NEW_DATA    : "green" ,
    MODIFY      : "blue"
};
export default {
    
    data(){
        return {
            showTable: false,
            btnDisabled: true,
            file: {},
            reader: new FileReader(),
            data: [],
            showDeleteBtn : false,
            fieldsToCompare : [
                "naviera_id",
                "naviera_id_departure",
                "pol",
                "pod",
                "from_format",
                "to_format",
                "neta",
                "public_value",
                "code",
                "container_id",
                "products_category_id",
                "atmosphere_id",
                "currency_id",
                "unit_payment",
            ] 
        }
    },
    props: {
        getRecharges : { type: Function, default: () => [] }
    },
    components: {
        UiModal,
        Button
    },
    computed: {
        ...mapState("lineas", ["showModalImportRecharges", 'rechargeTypes']),
    },
    methods: {
        ...mapActions(["ActionSetZindexModal"]),

        ...mapActions("lineas", ["actionsSetShowModalImportRecharges"]),

        openModal(ref){
            this.ActionSetZindexModal(true);
            this.$refs[ref].open();
        },
        closeModal(ref){
            this.file = {};
            
            this.data = [];
            this.showTable = false;
            this.ActionSetZindexModal(false);
            this.$refs[ref].close();
        },
        clearInput(){
            this.resetTable();
        },
        resetTable(){
            this.data = [] ;
            this.btnDisabled = true ;
            this.showTable = false ;
            this.$vToastify.stopLoader();
            document.getElementById('fileToImport').value = '';

            document.getElementById('fileToImport').value === '' ? this.showDeleteBtn = false : this.showDeleteBtn = true;
        },
        validFormatImport( dataToImport ){

            let valid = true ;

            let row = 2;

            for ( const data of dataToImport ) {
                
                if( ! data['CODE'] ){
                    this.$vToastify.error(`El campo 'CODE' es requerido`, `Error Fila ${ row }` ) ;
                    valid = false ;
                    break ;
                }

                if( ! data['ID NAVIERA'] || isNaN( data['ID NAVIERA'] ) ) {
                    this.$vToastify.error(`El campo 'ID NAVIERA' debe ser un número entero.` , `Error Fila ${ row }`) ;
                    valid = false ;
                    break ;
                }

                if( ! data['ID NAVIERA SALIDA'] || isNaN( data['ID NAVIERA SALIDA'] ) ) {
                    this.$vToastify.error(`El campo 'ID NAVIERA SALIDA' debe ser un número entero.` , `Error Fila ${ row }`) ;
                    valid = false ;
                    break ;
                }

                if( ! data['POD ID'] || isNaN( data['POD ID'] ) ) {
                    this.$vToastify.error(`El campo 'POD ID' debe ser un número entero.` , `Error Fila ${ row }`) ;
                    valid = false ;
                    break ;
                }

                if( ! data['POL ID'] || isNaN( data['POL ID'] ) ) {
                    this.$vToastify.error(`El campo 'POL ID' debe ser un número entero.` , `Error Fila ${ row }`) ;
                    valid = false ;
                    break ;
                }

                if( ! data['DESDE'] ) {
                    this.$vToastify.error(`El campo 'DESDE' es requerido.` , `Error Fila ${ row }`) ;
                    valid = false ;
                    break ;
                }

                if( ! data['HASTA'] ) {
                    this.$vToastify.error(`El campo 'HASTA' es requerido.` , `Error Fila ${ row }`) ;
                    valid = false ;
                    break ;
                }
                
                if( ! data['ID MONEDA'] || isNaN( data['ID MONEDA'] ) ) {
                    this.$vToastify.error(`El campo 'ID MONEDA' debe ser un número entero.` , `Error Fila ${ row }`) ;
                    valid = false ;
                    break ;
                }

                if( ! data['NETA'] ) {
                    this.$vToastify.error(`El campo 'NETA' debe ser tipo númerico.` , `Error Fila ${ row }`) ;
                    valid = false ;
                    break ;
                }

                if( ! data['PUBLICA'] ) {
                    this.$vToastify.error(`El campo 'PUBLICA' debe ser tipo númerico.` , `Error Fila ${ row }`) ;
                    valid = false ;
                    break ;
                }

                if( ! data['ID UNIDAD'] || isNaN( data['ID UNIDAD'] ) ) {
                    this.$vToastify.error(`El campo 'ID UNIDAD' debe ser un número entero.` , `Error Fila ${ row }`) ;
                    valid = false ;
                    break ;
                }

                if( ! data['ID UNIDAD PAGO'] || isNaN( data['ID UNIDAD PAGO'] ) ) {
                    this.$vToastify.error(`El campo 'ID UNIDAD PAGO' debe ser un número entero.` , `Error Fila ${ row }`) ;
                    valid = false ;
                    break ;
                }

                const codeFounded = this.rechargeTypes.find( rt => rt.name == data['CODE'] ) ?? {} ;

                if( ! codeFounded.id ) {
                    this.$vToastify.error(`Campo 'CODE'. El código '${ data['CODE'] }' no existe en Tipos de Recargos.` , `Error Fila ${ row }`) ;
                    valid = false ;
                    break ;
                }


                if( ! validateFormatDecimal( data['NETA'], false ) ) {
                    this.$vToastify.warning(`El campo 'NETA' debe ser un número entero o númerico de decimales, máximo dos, con puntos o comas. Ej: 10, 20,1, 101.12, 101,12` , `Alerta Fila ${ row }`) ;
                    valid = false ;
                    break ;
                }

                if( ! validateFormatDecimal( data['PUBLICA'] , false ) ) {
                    this.$vToastify.warning(`El campo 'PUBLICA' debe ser un número entero o númerico de decimales, máximo dos, con puntos o comas. Ej: 10, 20,1, 101.12, 101,12` , `Alerta Fila ${ row }`) ;
                    valid = false ;
                    break ;
                }

                row++;
            }

            return valid ;
        },
        formatData( data ){
            return data.map( d => ({
                id : {
                    value  : d["ID RECARGO"] ? d["ID RECARGO"] : null ,
                    change : Changes.NOT_CHANGES
                }, 
                naviera_id :{
                    value : d["ID NAVIERA"] ? d["ID NAVIERA"] : null ,
                    name : "",
                    change : Changes.NOT_CHANGES
                },
                naviera_id_departure : {
                    value : d["ID NAVIERA SALIDA"] ? d["ID NAVIERA SALIDA"] : null ,
                    name : "",
                    change : Changes.NOT_CHANGES
                } ,
                pol  : {
                    value : d["POL ID"] ? d["POL ID"] : null ,
                    name : "",
                    change : Changes.NOT_CHANGES
                } ,
                pod : {
                    value : d["POD ID"] ? d["POD ID"] : null ,
                    name : "",
                    change : Changes.NOT_CHANGES
                },
                from_format : {
                    value : d["DESDE"]  ? d["DESDE"]  : null ,
                    change : Changes.NOT_CHANGES
                } ,
                to_format   : {
                    value : d["HASTA"]  ? d["HASTA"]  : null ,
                    change : Changes.NOT_CHANGES ,
                } ,
                neta : {
                    value : d["NETA"]   ? d["NETA"]   : null ,
                    change : Changes.NOT_CHANGES
                },
                public_value : {
                    value : d["PUBLICA"]   ? d["PUBLICA"]   : null ,
                    change : Changes.NOT_CHANGES
                },
                code  : {
                    value : d["CODE"] ? d["CODE"] : null ,
                    name : "",
                    change : Changes.NOT_CHANGES
                },
                container_id           : {
                    value : d["ID UNIDAD"]   ? d["ID UNIDAD"] : null ,
                    name : "",
                    change : Changes.NOT_CHANGES
                },
                products_category_id   : {
                    value : d["ID COMMODITTY"]  ? d["ID COMMODITTY"] : null ,
                    name : "",
                    change : Changes.NOT_CHANGES
                } ,
                atmosphere_id          :{
                    value :  d["ID ATMOSFERA"]   ? d["ID ATMOSFERA"] : null ,
                    name : "",
                    change: Changes.NOT_CHANGES
                },
                currency_id            : {
                    value : d["ID MONEDA"]      ? d["ID MONEDA"] : null ,
                    name : "",
                    change : Changes.NOT_CHANGES
                },
                unit_payment           : {
                    value : d["ID UNIDAD PAGO"] ? d["ID UNIDAD PAGO"] : null ,
                    name : "",
                    change : Changes.NOT_CHANGES
                }
            }));
        },
        getPayload(){
            return this.data.map( d => ({
                id : d.id.value ,
                naviera_id : d.naviera_id.value ,
                naviera_id_departure : d.naviera_id_departure.value ,
                pol : d.pol.value ,
                pod : d.pod.value ,
                from : d.from_format.value ,
                to : d.to_format.value ,
                neta : d.neta.value ,
                public_value : d.public_value.value ,
                tariff_recharges_type : d.code.value.trim() ,
                container_id : d.container_id.value ,
                products_category_id : d.products_category_id.value ,
                atmosphere_id : d.atmosphere_id.value ,
                currency_id : d.currency_id.value ,
                unit_payment : d.unit_payment.value 
            }));
        },
        async handleSubmit(){

            const form = { tariff_recharges : this.getPayload() } ;
            
            this.$vToastify.loader("Importando Recargos...");

            try {
                
                await importTariffRecharges( form ) ;
                this.resetTable();
                this.closeModal('modal');

                this.getRecharges();

                this.$vToastify.stopLoader();
                return this.$vToastify.success("Recargos importados con éxito", "Realizado");

            } catch (error) {

                this.$vToastify.stopLoader();

                return this.$vToastify.error(
                    "Hubo un error al importar datos. Favor, revisar que todos los campos sean validos","Error"
                );
            }
        },
        async getFile() {

            const fileToImport = document.getElementById('fileToImport').value ;

            if( fileToImport === '' ) return this.resetTable();

            this.showDeleteBtn = fileToImport === '' ? false : true ;

            this.$vToastify.loader("Cargando Información...");

            try {
            
                const data = await this.formatImport( this.$refs.fileToImport.files[0] ) ;

                const valid = this.validFormatImport( data ) ;

                if( ! valid ) return this.resetTable();

                let dataFormat = this.formatData( data );

                this.data = await this.matchDataStyle( dataFormat ) ;

                this.showTable = true;
                this.btnDisabled = false ;
                this.showDeleteBtn = fileToImport === '' ? false : true ;

                return this.$vToastify.stopLoader();

            } catch (error) {
                this.resetTable();
                return this.$vToastify.error( "Hubo un error al leer Excel. Favor, recargue la página e intente nuevamente.", "¡Error!");
            }
        },
        async matchDataStyle( recharges ){

            const ids = recharges.filter( d => d.id.value ).map( d => d.id.value );

            let oldData = {} ;

            const { data } = await getRechargeFiltros( { ids } ) ;

            data.data.forEach( d => oldData[ d.id ] = d ) ;

            let info = data.info ;

            const newDataWithFormat = recharges.map( newData => {

                //asignciones de nuevos valores
                let newNaviera = info.navieras.find( ({id}) => id == newData.naviera_id.value );
                newData.naviera_id.name = newNaviera.name ;

                let newNavieraDeparture = info.navieras.find( ({id}) => id == newData.naviera_id_departure.value );
                newData.naviera_id_departure.name = newNavieraDeparture.name ;

                if( newData.pol.value ){
                    let newPol = info.ports.find( ({id}) => id == newData.pol.value );
                    newData.pol.name = newPol.name ;
                }
                
                let newPod = info.ports.find( ({id}) => id == newData.pod.value );
                newData.pod.name = newPod.name ;

                let newCurrency = info.currencies.find( ({id}) => id == newData.currency_id.value );
                newData.currency_id.name = newCurrency.name ;

                if( newData.atmosphere_id.value ){
                    let newAtmosphere = info.atmosferas.find( ({id}) => id == newData.atmosphere_id.value );
                    newData.atmosphere_id.name = newAtmosphere.name ;
                }
                
                let newContainer = info.containers.find( ({id}) => id == newData.container_id.value );
                newData.container_id.name = newContainer.name ;

                if( newData.products_category_id.value ){
                    let newCommodity = info.commodity.find( ({id}) => id == newData.products_category_id.value );
                    newData.products_category_id.name = newCommodity.name ;
                }

                let newUnityPayment = info.unityPayments.find( ({id}) => id == newData.unit_payment.value );
                newData.unit_payment.name = newUnityPayment.name ;

                if( ! newData.id.value ){
                    newData.id.change = Changes.NEW_DATA ;
                    newData.naviera_id.change = Changes.NEW_DATA ;
                    newData.naviera_id_departure.change = Changes.NEW_DATA ;
                    newData.pol.change = Changes.NEW_DATA ;
                    newData.pod.change = Changes.NEW_DATA ;
                    newData.from_format.change = Changes.NEW_DATA ;
                    newData.to_format.change = Changes.NEW_DATA ;
                    newData.neta.change = Changes.NEW_DATA ;
                    newData.public_value.change = Changes.NEW_DATA ;
                    newData.code.change = Changes.NEW_DATA ;
                    newData.container_id.change = Changes.NEW_DATA ;
                    newData.products_category_id.change = Changes.NEW_DATA ;
                    newData.atmosphere_id.change = Changes.NEW_DATA ;
                    newData.currency_id.change = Changes.NEW_DATA ;
                    newData.unit_payment.change = Changes.NEW_DATA ;
                }
                else {

                    // Se realiza comparación de campos
                    
                    this.fieldsToCompare.forEach(field => {
                        const newField = newData[field];
                        const oldFieldGroup = oldData[newData.id.value];

                        if (newField && oldFieldGroup && typeof oldFieldGroup[field] !== 'undefined') {
                            newField.change = newField.value == oldFieldGroup[field]
                                ? Changes.NOT_CHANGES
                                : Changes.MODIFY;
                        } else {
                            // Si no hay valor viejo con qué comparar, asumimos que es nuevo o cambiado
                            if (newField) {
                                newField.change = Changes.NEW_DATA;
                            }
                        }
                    });
                 
                }
                return newData ;
            }) ;

            return newDataWithFormat ;
        },
        async formatImport( dataInput ){

            const dataImport = await readXlsxFile( dataInput ) ;

            if( dataImport.length == 0 || ! dataImport ) return [] ;

            let data = [] ;

            const headers = dataImport[0] ;

            dataImport.forEach( ( val , key ) => {

                if( key !== 0 ){
                    let item = {} ;
                    headers.forEach( ( h, hIndex ) => item[ h ] = val[ hIndex ] ) ;
                    data.push( item ) ;
                }
            }) ;

            data = data.map( d => ({...d, 
                DESDE : typeof d.DESDE == "string" ? d.DESDE : formatDate( new Date( d.DESDE ) ),
                HASTA : typeof d.HASTA == "string" ? d.HASTA : formatDate( new Date( d.HASTA ) ),
                PUBLICA : d.PUBLICA ? +d.PUBLICA.toString().trim().replace(",", ".") : null,
                NETA :    d.NETA    ? +d.NETA.toString().trim().replace(",", ".")    : null
            }))
            
            return data ;
        },
    },
    watch: {
        showModalImportRecharges: function( _new ){
            _new ? this.openModal("modal") : this.closeModal("modal") ;
        }
        
    },
}
</script>

<style>
:root {
    --import-recharges-gray-color : #575a57 ;
    --import-recharges-red-color : #dc143c ;
    --import-recharges-blue-color : rgba(12, 103, 201, .631372549) ;
    --import-recharges-green-color : #2da44e ;
    --import-recharges-white-color : #fff ;

}
#import-recharges .info {
    width: 20px  ;
    height: 20px ;
    position: relative;
    border-radius: 3px;
}

#import-recharges input[type=file]  {
    display: unset;
}

#import-recharges .delete {
    position: absolute;
    left: 95%;
    font-size: 1.2rem;
    color: var(--import-recharges-red-color);
    cursor: pointer;
    transition: transform .3s ease-out;
}

#import-recharges .red {
    background-color: var(--import-recharges-red-color);
}

#import-recharges .blue {
    background-color: var( --import-recharges-blue-color);
    color: var(--import-recharges-white-color);
}

#import-recharges .green {
    background-color: var( --import-recharges-green-color);
    color: var(--import-recharges-white-color);
}

#import-recharges .ui-modal--size-large > .ui-modal__wrapper > .ui-modal__container {
    width: 90% !important;
}

#import-recharges .import {
    width: inherit;
    cursor: pointer;
}

#import-recharges .b-order{
    border: 1.5px var( --import-recharges-gray-color ) dashed;
}

#import-recharges .import::before {
    color: var(--import-recharges-white-color) ;
    content: "Seleccione archivo";
    display: inline-block;
    background: var( --import-recharges-gray-color );
    border-radius: 3px;
    padding: 5px 8px;
    outline: none;
    white-space: nowrap;
    cursor: pointer;
}

#import-recharges input[type="file"]::-webkit-file-upload-button {
    visibility: hidden;
}

#import-recharges .message-wait {
    min-height: 600px;
    display: flex;
    justify-content: center;
    align-items: center;
    color: var( --import-recharges-gray-color );
}

</style>
